import { Method } from "axios";
import notify from "devextreme/ui/notify";
import { BodyType, createRequest } from "../redux/base/request";
import { ApiResponse, verfiyResponse } from "../types/models/base-model";

export class BaseService {
  sendRequest = async (
    url: string,
    method: Method = "GET",
    token: string,
    language: string,
    data?: {},
    bodyType?: BodyType
  ) => {
    const response: ApiResponse = await createRequest({
      url,
      method,
      token,
      lang: language,
      body: data,
      bodyType,
    });
    if (verfiyResponse(response)) {
      return response.Result;
    } else notify(response.Message, "error");
  };

  sendRequestWithApiResponse = async (
    url: string,
    method: Method = "GET",
    token: string,
    language: string,
    data?: {},
    bodyType?: BodyType
  ) => {
    const response: ApiResponse = await createRequest({
      url,
      method,
      token,
      lang: language,
      body: data,
      bodyType,
    });
    if (verfiyResponse(response)) {
      return response;
    } else notify(response.Message, "error");
  };
}

export default BaseService;
